export const c_card_m_selectable_raised_m_selected_raised_Transition = {
  "name": "--pf-c-card--m-selectable-raised--m-selected-raised--Transition",
  "value": "transform .25s linear, box-shadow .25s linear",
  "var": "var(--pf-c-card--m-selectable-raised--m-selected-raised--Transition)"
};
export default c_card_m_selectable_raised_m_selected_raised_Transition;